import { Button, Divider } from "@dreambigger/design-system";
import { memo } from "react";

type Props = {
  onClick: React.MouseEventHandler<HTMLElement>;
};

/**
 * This component will instruct the user on how to upload a CSV File via Cloudsponge.
 * Most likely will only be used by Thank You Notes and RSVP Invite Notes flow so keeping custom props to a minimum for now.
 */
const CloudspongeCSVUploadInstructions = ({ onClick }: Props) => {
  return (
    <>
      <div
        className="mh-5 pa-3 flex flex-column items-center"
        style={{
          backgroundColor: "#f6f6f6",
          borderRadius: "8px",
        }}
      >
        <p className="ttu fwb underline">Formatting Your File</p>

        <p>
          To format your file using a program such as Microsoft Excel, please
          follow the guidelines below:
        </p>

        <ol className="tc" style={{ listStylePosition: "inside" }}>
          <li>
            Place your data in to three separate columns for{" "}
            <span className="fwb">First Name</span> (Column A),{" "}
            <span className="fwb">Last Name</span> (Column B), and{" "}
            <span className="fwb">Email Addresses</span> (Column C).
          </li>
          <li>Make sure each column has a header (e.g. First Name)</li>
          <li> No special characters or Facebook Addresses.</li>
          <li>
            Save or export your file as a <span className="fwb">.csv</span>{" "}
            before uploading.
          </li>
        </ol>
        <img
          className="mt-2 w-100 md_w-50 mb-3"
          src="https://res.cloudinary.com/cotribute/image/upload/v1510597015/csv_screenshot_fyioq6.png"
          alt="CSV File Example"
        />
      </div>

      <Divider className="mv-6" />

      <div className="tc">
        <Button
          onClick={onClick}
          type="primary"
          className={`b-primary ttu h-7 lightenPrimaryBkd`}
          style={{
            minWidth: 200,
          }}
        >
          Upload File
        </Button>
      </div>
    </>
  );
};

export default memo(CloudspongeCSVUploadInstructions);
